/* tslint:disable */
export interface EvaluationDossierModel {
    code: string,
    valeurTexte: string,
    libelle?: string
}

export const evaluationDossier: EvaluationDossierModel[] = [
    { code: '-1', valeurTexte: 'N/A' },

    { code: '0', valeurTexte: '0-Mineur' },
    { code: '1', valeurTexte: '0-Mineur - enjeu corporatif' },

    { code: '2', valeurTexte: '1-Modéré' },
    { code: '3', valeurTexte: '1-Modéré - enjeu corporatif' },

    { code: '4', valeurTexte: '2-Sérieux' },
    { code: '5', valeurTexte: '2-Sérieux - enjeu corporatif' },

    { code: '6', valeurTexte: '3-Critique' },
    { code: '7', valeurTexte: '3-Critique - enjeu corporatif' },
]